import {
	englishDataset,
	englishRecommendedTransformers,
	CensorContext,
	RegExpMatcher,
	TextCensor,
} from 'obscenity';

import {useFirebaseAuthUserStore} from '../stores/FirebaseAuthUserStore';

const matcher = new RegExpMatcher({
	...englishDataset.build(),
	...englishRecommendedTransformers,
});

const asteriskStrategy = (context: CensorContext) =>
	'*'.repeat(context.matchLength);
const censor = new TextCensor().setStrategy(asteriskStrategy);

export const censorObscenities = (val: string) => {
	if (containsObscenities(val)) {
		const matches = matcher.getAllMatches(val);
		const censored = censor.applyTo(val, matches);
		return censored;
	}

	return val;
};

export const containsObscenities = (val: string) => {
	return matcher.hasMatch(val);
};

export const currentlyMasterFirebaseUser = () => {
	// Zustand
	const firebaseAuthUser =
		useFirebaseAuthUserStore.getState().firebaseAuthUser;

	return isMasterFirebaseUser(firebaseAuthUser?.uid);
};

export const getDebug = (
	domain:
		| 'account'
		| 'auth'
		| 'community'
		| 'home'
		| 'misc'
		| 'news'
		| 'posts'
		| 'users',
) => {
	switch (domain) {
		case 'account':
			return parseBoolean(process.env.REACT_APP_DEBUG_ACCOUNT)
				? parseBoolean(process.env.REACT_APP_DEBUG_ACCOUNT)
				: false;
		case 'auth':
			return parseBoolean(process.env.REACT_APP_DEBUG_AUTH)
				? parseBoolean(process.env.REACT_APP_DEBUG_AUTH)
				: false;
		case 'community':
			return parseBoolean(process.env.REACT_APP_DEBUG_COMMUNITY)
				? parseBoolean(process.env.REACT_APP_DEBUG_COMMUNITY)
				: false;
		case 'home':
			return parseBoolean(process.env.REACT_APP_DEBUG_HOME)
				? parseBoolean(process.env.REACT_APP_DEBUG_HOME)
				: false;
		case 'misc':
			return parseBoolean(process.env.REACT_APP_DEBUG_MISC)
				? parseBoolean(process.env.REACT_APP_DEBUG_MISC)
				: false;
		case 'news':
			return parseBoolean(process.env.REACT_APP_DEBUG_NEWS)
				? parseBoolean(process.env.REACT_APP_DEBUG_NEWS)
				: false;
		case 'posts':
			return parseBoolean(process.env.REACT_APP_DEBUG_POSTS)
				? parseBoolean(process.env.REACT_APP_DEBUG_POSTS)
				: false;
		case 'users':
			return parseBoolean(process.env.REACT_APP_DEBUG_USERS)
				? parseBoolean(process.env.REACT_APP_DEBUG_USERS)
				: false;
	}
};

export const isMasterFirebaseUser = (uid: null | string | undefined) => {
	return uid === process.env.REACT_APP_MASTER_UID;
};

export const parseBoolean = (arg: string | undefined) => {
	if (arg === 'true') {
		return true;
	}

	return false;
};
